module.exports = __webpack_public_path__ + "img/headband.4ea15d71.png";